import { autoinject } from 'aurelia-framework';
import { PenOrderTabProps } from '../tabs';

@autoinject
export class Tab {
  data: PenOrderTabProps;

  activate(data: PenOrderTabProps) {
    this.data = data;
  }
}
